import {
  onSelectScriptTypeOptions,
  onSelectManagementZones,
  onSelectPreviousScript,
  onEnterGenerateZones,
  onEnterZonesReview,
  onEnterPlantingPlan,
  onFinishFlow
} from './stepActions';

export const defaultScriptFlowDefinition = [
  onSelectScriptTypeOptions,
  onSelectManagementZones,
  onEnterPlantingPlan,
  onFinishFlow
];

export const previousScriptFlowDefinition = [
  onSelectScriptTypeOptions,
  onSelectManagementZones,
  onSelectPreviousScript,
  onEnterPlantingPlan,
  onFinishFlow
];

export const generateZonesFlowDefinition = [
  onSelectScriptTypeOptions,
  onSelectManagementZones,
  onEnterGenerateZones,
  onEnterZonesReview,
  onEnterPlantingPlan,
  onFinishFlow
];
